import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import PendingApproval from "@/pages/auth/PendingApproval";

export default function ProtectedRoute({ children, role, clinicRole }) {
  const { user, profile, clinic, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--bg-base))]">
        <div className="text-sm text-[hsl(var(--text-tertiary))]">Carregando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // user signed up but profile row not yet created (rare race) — wait for trigger
  if (!profile) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--bg-base))]">
        <div className="text-sm text-[hsl(var(--text-tertiary))]">Sincronizando perfil...</div>
      </div>
    );
  }

  if (profile.role === "superadmin") return children;

  if (role && profile.role !== role) {
    return <Navigate to={profile.role === "professional" ? "/app" : "/portal"} replace />;
  }

  // 2. Portão de Aprovação Administrativa e Assinatura
  if (profile.role === 'professional' && profile.email !== 'romuloblaudt@hotmail.com') {
    // Verificar Bloqueio Manual
    if (profile.is_blocked) {
      return <Navigate to="/pending-approval" state={{ blocked: true }} replace />;
    }

    // Verificar Vencimento de Assinatura
    const expiresAt = profile.subscription_expires_at ? new Date(profile.subscription_expires_at) : null;
    if (expiresAt && expiresAt < new Date()) {
      return <Navigate to="/pending-approval" state={{ expired: true }} replace />;
    }

    // Verificar Aprovação Inicial
    if (!profile.is_approved) {
      return <Navigate to="/pending-approval" replace />;
    }
  }

  // Clinic role restriction
  if (clinicRole) {
    const roles = Array.isArray(clinicRole) ? clinicRole : [clinicRole];
    // Se o profissional é solo (não tem clínica), ele é o admin de si mesmo
    const myRole = clinic?.my_role || (profile.role === 'professional' ? 'admin' : null);
    
    if (!myRole || !roles.includes(myRole)) {
      return <Navigate to="/app" replace />;
    }
  }

  return children;
}
